import React, { useState, useEffect } from 'react';
import { FiClock } from 'react-icons/fi';
import { ProgressCircular } from '@/components/custom/progress';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Widget, WidgetBody, WidgetCount, WidgetHeader, WidgetHeaderContent, WidgetTitle } from '@/components/custom/widget';

export function ExamsQuestionsClock(props) {
  const { t } = useTranslation();
  const { questionBooksUser, questionBook, setElapsedTime, examTime, playful = false } = props;
  const [clock, setClock] = useState();
  const [percentageTime, setPercentageTime] = useState();
  let intervalId = null;

  useEffect(() => {
    tick();
    if (intervalId !== null) {
      clearInterval(intervalId);
    }
    intervalId = setInterval(() => tick(), 1000);
  }, []);

  const tick = () => {
    if (questionBook && questionBooksUser) {
      const createdAt = questionBooksUser.created_at;
      const resolutionTime = moment(`1970-01-01 ${questionBook['resolution-time']}`);
      const newClock = resolutionTime.subtract(moment().diff(createdAt, 'seconds'), 'second');

      const durationSeconds = moment(questionBook['resolution-time'], 'HH:mm').diff(moment().startOf('day'), 'seconds');
      const passedSeconds = moment().diff(createdAt, 'seconds');
      const percentage = ((durationSeconds - passedSeconds) * 100) / durationSeconds;

      if (percentage <= 0) {
        clearInterval(intervalId);
      } else {
        setPercentageTime(100 - percentage);
        setClock(newClock);
        setElapsedTime(passedSeconds);
      }
    }
  };

  // Variante compacta usada no cabeçalho do tema lúdico.
  if (playful) {
    return (
      <div className="flex items-center gap-2 rounded-full bg-white px-4 py-2 shadow-card">
        <FiClock className="h-4 w-4 shrink-0 text-[var(--color-secondary)]" />
        <span
          className="text-sm font-extrabold tabular-nums"
          style={{ color: '#222731' }}
        >
          {clock ? clock.format('H:mm:ss') : examTime ? `${examTime}h` : '—'}
        </span>
      </div>
    );
  }

  return (
    <Widget className="mb-2">
      <WidgetHeader>
        <WidgetHeaderContent>
          <WidgetTitle>{t('exams.time')}</WidgetTitle>
          <WidgetCount>
            <span>{!examTime ? 'Sem tempo definido!' : examTime + 'h'}</span>
          </WidgetCount>
        </WidgetHeaderContent>
      </WidgetHeader>

      <WidgetBody className="flex justify-center">
        {clock && (
          <ProgressCircular
            time={clock.format('H:mm:ss')}
            valueNow={percentageTime}
          />
        )}
      </WidgetBody>
    </Widget>
  );
}
